import { createReducer, on } from '@ngrx/store';
import { UserApiActions, MembershipListApiActions } from './user-group.actions';
import { initialstate, adapter, selectUserIdFromParent } from './user-group.state';

export const userGroupReducer = createReducer(
  initialstate,
  on(UserApiActions.userGroupsLoaded, (state, { groups }) => adapter.addMany(groups, state)),
  on(MembershipListApiActions.userGroupDeleted, (state, { group }) =>
    adapter.removeOne(selectUserIdFromParent(group), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectUserIds = selectIds;

export const selectUserEntities = selectEntities;

export const selectAllGroups = selectAll;
